import {RaEvent, RaEventType} from "./RaEvent";



export class EnableExitButtonEvent extends RaEvent {
    static TYPE:RaEventType = "enable_exit_button_event";
    constructor() {
        super(EnableExitButtonEvent.TYPE);
    }
}

export class DisableExitButtonEvent extends RaEvent {
    static TYPE:RaEventType = "disable_exit_button_event";
    constructor() {
        super(DisableExitButtonEvent.TYPE);
    }
}
